import { queryOptions } from '@tanstack/react-query';

import { gammaRolesClient } from './client';

export const GAMMA_ROLES_QUERY_KEYS = {
  catalog: 'gamma-permission-catalog',
  roles: 'gamma-roles',
  role: 'gamma-role',
  roleMembers: 'gamma-role-members',
  memberPermissions: 'gamma-member-permissions',
};

/**
 * Immutable for the life of a deployment, same as the entity plane's
 * catalogue — worth caching hard rather than refetching per board visit.
 */
export const _getGammaPermissionCatalog = (enabled = true) =>
  queryOptions({
    enabled,
    queryKey: [GAMMA_ROLES_QUERY_KEYS.catalog],
    queryFn: () => gammaRolesClient.getCatalog(),
    staleTime: Infinity,
    gcTime: Infinity,
  });

/**
 * Unlike the entity plane's roles, the Gamma plane has exactly one role
 * namespace — there is no entity to scope by, so these queries carry no extra
 * key beyond the query itself.
 */
export const _getGammaRoles = (enabled = true) =>
  queryOptions({
    enabled,
    queryKey: [GAMMA_ROLES_QUERY_KEYS.roles],
    queryFn: () => gammaRolesClient.getRoles(),
  });

export const _getGammaRole = (roleId?: string | null) =>
  queryOptions({
    enabled: !!roleId,
    queryKey: [GAMMA_ROLES_QUERY_KEYS.role, roleId],
    queryFn: () => gammaRolesClient.getRole(roleId as string),
  });

export const _getGammaRoleMembers = (roleId?: string | null) =>
  queryOptions({
    enabled: !!roleId,
    queryKey: [GAMMA_ROLES_QUERY_KEYS.roleMembers, roleId],
    queryFn: () => gammaRolesClient.getRoleMembers(roleId as string),
  });
